import { render } from "./radio.vue?vue&type=template&id=1f9d5d29&scoped=true"
import script from "./radio.vue?vue&type=script&lang=js"
export * from "./radio.vue?vue&type=script&lang=js"

import "./radio.vue?vue&type=style&index=0&id=1f9d5d29&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f9d5d29"]])

export default __exports__